import 'roboto-fontface/css/roboto/roboto-fontface.css'
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n'
import router from '@/router'
import store from '@/store'
import {AUTH_TOKEN, CURRENT_UI_LANGUAGE, SUPPORTED_LANGUAGES} from "@/store/getter-types";
import {
  AUTH_LOG_USER_IN_WITH_TOKEN,
  INIT_STORE,
  SET_CID_MODE,
  SET_MODE,
  SET_TT_MODE,
  SWITCH_APPLICATION_LANGUAGE
} from "@/store/action-types";
import {isTokenExpiration} from "@/services/util";
import {PiniaVuePlugin, createPinia} from 'pinia'
import App from "@/App.vue";
import Language from "@/model/Language";

Vue.config.productionTip = false;

const urlParams: URLSearchParams = new URLSearchParams(window.location.search)
const mode: string | null = urlParams.get('mode')
if(mode){
  store.dispatch(SET_MODE, mode)
  localStorage.setItem("mode", mode)
} else if(localStorage.getItem('mode')) {
  store.dispatch(SET_MODE, localStorage.getItem('mode'))
}

const cid: string | null = urlParams.get('cid')
if(cid){
  store.dispatch(SET_CID_MODE, cid)
  localStorage.setItem("cid", cid)
} else if(localStorage.getItem('cid')) {
  store.dispatch(SET_CID_MODE, localStorage.getItem('cid'))
}

const tt: string | null = urlParams.get('tt')
if(tt){
  store.dispatch(SET_TT_MODE, tt)
  localStorage.setItem("tt", tt)
} else if(localStorage.getItem('tt')) {
  store.dispatch(SET_TT_MODE, localStorage.getItem('tt'))
}

(async () => {
  try {
    // ak je mod kiosk a idem priamo na login page, tak inicializacia existujuceho prihlasenia nebude
    // rozhodne sa az login page co spravit
    if (mode === 'kiosk' && window.location.pathname.includes('/login')) {
      // empty
    } else {
      await store.dispatch(INIT_STORE)

      const token = store.getters[AUTH_TOKEN]

      if (token) {

        let isTokenExpired: boolean = isTokenExpiration(token)

        if (!isTokenExpired) {
          await store.dispatch(AUTH_LOG_USER_IN_WITH_TOKEN, token)
        }
      }
    }
  } finally {
    Vue.use(PiniaVuePlugin)

    new Vue({
      router,
      store,
      i18n,
      vuetify,
      pinia: createPinia(),
      render: h => h(App),
      created () {
        const supportedLanguages: Language[] = store.getters[SUPPORTED_LANGUAGES]
        const foundLanguage: Language | undefined = supportedLanguages.find((item: Language) => item.code === i18n.locale)
        store.dispatch(SWITCH_APPLICATION_LANGUAGE, foundLanguage ? foundLanguage :store.getters[CURRENT_UI_LANGUAGE])
      }
    }).$mount('#app')
  }
})()
